(function() {    
    let tlGiftInCartWidgetClone;
    let originalFuncGetGiftHTML;

    function checkIfAnyOfferStateIsMet() {
        const offers = window.tlGiftInCartWidget.offers;

        return offers.some((offer) => {
            const { conditionState } = window.tlGiftInCartWidget.getOfferState(
                offer.id,
                offer.module
            );

            return (
                conditionState ===
                window.tlGiftInCartWidget.CONDITION_STATE.MET_BEFORE_CLAIM
            );
        });
    }
    
    Object.defineProperty(window, "tlGiftInCartWidget", {
        get() {
            return tlGiftInCartWidgetClone;
        },
        set(val) {
            if (val && !tlGiftInCartWidgetClone) {
                tlGiftInCartWidgetClone = val;
                val.renderGICWidget = async () => {
                    document
                        .querySelectorAll(".salepify-gic__widget-wrapper, .salepify-gic__gic-container")
                        .forEach((el) => el.remove());

                    if (!checkIfAnyOfferStateIsMet()) return;
                    
                    let { selector, emptySelector, position, emptyPosition } = window.tlGiftInCartWidget.targetElements;
                    const targetElements = document.querySelectorAll(window.tlGiftInCartWidget.isEmptyCart() ? emptySelector : selector);
                    const insertPosition = window.tlGiftInCartWidget.isEmptyCart() ? emptyPosition : position;

                    if (!targetElements.length) return;

                    const GICContainerHTML = window.tlGiftInCartWidget.getGICContainerHTML();
                    targetElements.forEach((el) => {
                        const container = document.createElement("div");
                        container.className = "salepify-gic__gic-container";
                        container.innerHTML = GICContainerHTML;

                        switch (insertPosition) {
                            case "prepend":
                            case "afterbegin":
                                el.prepend(container);
                                break;
                            case "after":
                            case "afterend":
                                el.insertAdjacentElement("afterend", container);
                                break;
                            case "before":
                            case "beforebegin":
                            default:
                                el.insertAdjacentElement("beforebegin", container);
                                break;
                        }
                    });

                    await window.tlGiftInCartWidget.addOfferCardsToGICContainer(window.tlGiftInCartWidget.offers);

                    const existingModal = document.querySelector(".salepify-gic__gift-selector-modal");
                    if (!existingModal) {
                        const GICGiftSelectorShellHTML = window.tlGiftInCartWidget.getGICGiftSelectorShellHTML();
                        const modal = document.createElement("dialog");
                        modal.className = "salepify-gic__gift-selector-modal";
                        modal.innerHTML = GICGiftSelectorShellHTML;
                        document.body.appendChild(modal);
                        modal.addEventListener("click", (e) => {
                            if (e.target === modal) {
                                modal.close();
                            }
                        });
                    }
                    window.tlGiftInCartWidget.setupOfferScroll();
                }
                val.getGiftHTML = ({ id: giftId, handle, price, image, quantity, title, available }, offer, conditionState) => {
                    if (price > 1600) return ""
                    const {
                        CONDITION_STATE: { MET_BEFORE_CLAIM },
                        MODULE: { BOGO },
                        AUTO_ADD_TYPE: { SELECT_TO_ADD },
                        GIFT_TYPE: { VARIANT },
                    } = window.tlGiftInCartWidget;
                    const {
                        discount_type: discountType,
                        discount_value: discountValue,
                        is_gift_qty_fixed: isGiftQtyFixed,
                        gift_type: giftType,
                        gift_qty: giftQty,
                        type
                    } = offer;
                    const discountedPrice = window.tlGiftInCartWidget.utils.getPriceAfterDiscount(price, discountType, discountValue);
                    const discountedText = discountedPrice === 0 ? window.tlGiftInCartWidget.translations.general.free_text : window.tlGiftInCartWidget.utils.displayMoney(discountedPrice * 100, window.tlGiftInCartWidget.moneyFormat);
                    const regularText = window.tlGiftInCartWidget.utils.displayMoney(price * 100, window.tlGiftInCartWidget.moneyFormat);
                    const isOutOfStock = !available;
                    const shouldShowQuantityBadge = type === BOGO || isGiftQtyFixed;
                    const ruleKey = window.tlGiftInCartWidget.utils.getRuleKey(offer.id, offer.module);
                    const selectedQty = window.tlGiftInCartWidget.selectedGiftQuantitiesByRuleKey.get(ruleKey)?.[giftId] ?? 0;
                    const isSelected = selectedQty > 0;

                    return `
                        <div class="salepify-gic__gift-selector-item ${isOutOfStock ? "salepify-gic__gift-selector-item--disabled" : ""} ${isSelected ? "salepify-gic__gift-selector-item--selected" : ""}"
                            data-gift-id="${giftId}"
                            data-search-title="${window.tlGiftInCartWidget.utils.escapeHtmlAttr(window.tlGiftInCartWidget.utils.normalizeSearchTitle(title))}"
                            ${isGiftQtyFixed && conditionState === MET_BEFORE_CLAIM && !isOutOfStock ? `
                                onclick="window.tlGiftInCartWidget.toggleSelectGift(this, ${giftId}, ${offer.id}, '${offer.module}')"
                                style="cursor: pointer;"
                            ` : ""}
                        >

                            <div class="salepify-gic__gift-selector-thumb">
                                <img src="${image}" alt="${title}" />
                                ${shouldShowQuantityBadge ? `
                                    <div class="salepify-gic__gift-selector-qty-badge">
                                        ${"x" + (quantity ?? giftQty)}
                                    </div>
                                ` : ""}
                            </div>
                            <div class="salepify-gic__gift-selector-info">
                                <a class="salepify-gic__gift-selector-name"
                                    href="/products/${handle}?variant=${giftId}"
                                >
                                    ${title}
                                </a>
                                ${isOutOfStock ? `
                                    <div class="salepify-gic__gift-selector-out-stock">
                                        ${this.translations.general.out_of_stock}
                                    </div>
                                ` : `
                                    <div class="salepify-gic__gift-selector-price">
                                        <div class="salepify-gic__gift-selector-discounted-price">
                                            ${discountedText}
                                        </div>
                                        <div class="salepify-gic__gift-selector-regular-price">
                                            ${regularText}
                                        </div>
                                    </div>
                                `}
                            </div>
                            ${isGiftQtyFixed ? `
                                <span class="salepify-gic__gift-selector-checkbox
                                        ${isOutOfStock ? "salepify-gic__gift-selector-checkbox--disabled" : ""}"
                                    aria-hidden="true"
                                    style="display: ${conditionState === MET_BEFORE_CLAIM && type !== BOGO ? "block" : "none"};"
                                >
                                </span>
                            ` : `
                                <div class="salepify-gic__gift-quantity-selector
                                    ${isOutOfStock ? "salepify-gic__gift-quantity-selector--disabled" : ""}"
                                    style="display: ${conditionState === MET_BEFORE_CLAIM && type !== BOGO ? "flex" : "none"};"
                                >
                                    <button
                                        class="salepify-gic__gift-quantity-button salepify-gic__gift-quantity-button--decrease"
                                        onclick="window.tlGiftInCartWidget.handleDecreaseGiftQuantity(this, ${giftId}, ${offer.id}, '${offer.module}')"
                                    >
                                        –
                                    </button>
                                    <input
                                        class="salepify-gic__gift-quantity-input"
                                        gift-id="${giftId}"
                                        type="text"
                                        value="${selectedQty}"
                                        onchange="window.tlGiftInCartWidget.handleChangeGiftQuantity(this, ${giftId}, ${offer.id}, '${offer.module}')"
                                    />
                                    <button
                                        class="salepify-gic__gift-quantity-button salepify-gic__gift-quantity-button--increase"
                                        onclick="window.tlGiftInCartWidget.handleIncreaseGiftQuantity(this, ${giftId}, ${offer.id}, '${offer.module}')"
                                    >
                                        +
                                    </button>
                                </div>
                            `}
                            
                        </div>
                    `;
                }
            }
        },
        configurable: true
    });
})();